export class Users {
  constructor(
    public enabled?: boolean,
    public phoneNumber?: string,
    public campaignIds?: string[],
    public updateAt?: number,
    public createAt?: number,
    public email?: string,
    public id?: string,
    public name?: number,
    public campaignList?: any[],
    public userId?: string,
    public modifiedBy?: string
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/users.model.ts